import { render } from "./Treatments.vue?vue&type=template&id=6b41c1fd&scoped=true"
const script = {}

import "./Treatments.vue?vue&type=style&index=0&id=6b41c1fd&lang=sass&scoped=true"
import "./Treatments.vue?vue&type=style&index=1&id=6b41c1fd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b41c1fd"]])

export default __exports__